import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { debounce } from 'lodash';
import {
  IconButton,
  Card,
  Form,
  RouteWrapper,
  HeadingSection,
  ServiceHistoryTable,
  Section,
  Pagination,
} from '../../components';
import { getServiceHistory } from '../../redux/actions/service';

interface Props {
  goBack: () => void;
  getServiceHistory: (
    search?: string,
    page?: number,
  ) => Promise<{ lastPage: boolean; services: IService[] }>;
}

interface State {
  services: IService[];
  isFetching: boolean;
  search: string;
  page: number;
  lastPage: boolean;
}

class Route extends React.Component<Props, State> {
  state = {
    services: [] as IService[],
    isFetching: true,
    search: '',
    page: 0,
    lastPage: true,
  };

  async componentDidMount() {
    this.searchServiceHistory();
  }

  searchServiceHistory = async (search: string = '') => {
    this.setState({ isFetching: true });
    const { services, lastPage } = await this.props.getServiceHistory(search);
    this.setState({ services });
    this.setState({ search, lastPage, isFetching: false });
  };

  getPage = async (page: number) => {
    this.setState({ isFetching: true });
    const { services, lastPage } = await this.props.getServiceHistory(
      this.state.search,
      page,
    );
    this.setState({
      page,
      services,
      lastPage,
      isFetching: false,
    });
  };

  render() {
    return (
      <RouteWrapper
        title="Service History"
        requireAuth
        requirePermission="MANAGE_SERVICE"
      >
        <HeadingSection
          title="Service History"
          controls={[
            <IconButton
              icon="undo"
              className="is-default is-pulled-right"
              handleClick={() => {
                this.props.goBack();
              }}
              key="return"
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <Card list>
            <Form
              fields={[
                {
                  name: 'search',
                },
              ]}
              type="search"
              hasButton={false}
              handleChange={debounce(
                ({ search }) => this.searchServiceHistory(search),
                250,
              )}
            />
          </Card>
          <ServiceHistoryTable
            services={this.state.services}
            loading={this.state.isFetching}
          />
          {!this.state.isFetching && (
            <Pagination
              page={this.state.page}
              lastPage={this.state.lastPage}
              handleUpdate={(page) => {
                this.getPage(page);
              }}
            />
          )}
        </Section>
      </RouteWrapper>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  goBack: () => dispatch(goBack()),
  getServiceHistory: (search: string = '', page: number = 0) =>
    dispatch(getServiceHistory(search, page)),
});

export default connect(undefined, mapDispatchToProps)(Route);
